<template>
  <div class="listFooter row justify-between items-center q-px-md">
    <div>
      <span class="q-mr-sm">Powered by</span>
      <a href="javascript: void(0);" target="_blank">
        <q-img basic width="60px" src="~assets/images/home/logo.svg" />
      </a>
    </div>
<!--    <div>-->
<!--      <span>Are you the owner?</span>-->
<!--      <a class="link" target="_blank" href="https://business.horego.com">-->
<!--        Contact us-->
<!--      </a>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      // logoJump: 'https://business.horego.com/?utm_source=desty-menu&utm_medium=pre-register&utm_campaign=footer-pr&utm_content=xxx',
    };
  },
};
</script>

<style lang="scss" scoped>
.listFooter {
  height: 50px;
  background: #ffffff;
  width: 100%;
  font-size: 12px;
  color: #6b7280;
  position: absolute;
  bottom: 0;
  .link {
    color: $dark !important;
    text-decoration: underline !important;
  }
}
</style>
